<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,body,#app {
  font-family: Microsoft YaHei, "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  position: absolute;
  overflow-y: hidden;
}



</style>



// WEBPACK FOOTER //
// src/App.vue